import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

const LEGACY_REPORT_STATUS_OPTIONS = [
  {
    id: "NONE",
    name: "None",
  },
  {
    id: "IN_PROGRESS",
    name: "In Progress",
  },
  {
    id: "ANALYZING",
    name: "Analyzing",
  },
  {
    id: "PARTIAL",
    name: "Partial",
  },
  {
    id: "COMPLETE",
    name: "Complete",
  },
  {
    id: "DISPUTE",
    name: "In Dispute",
  },
  {
    id: "SENT",
    name: "Sent",
  },
  {
    id: "ACTION_REQUIRED",
    name: "Action Required",
  },
  {
    id: "UNRESPONSIVE",
    name: "Unresponsive",
  },
];

export function LegacyReportStatusFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.report_status?.split(",") || []}
      onSelectionChange={(keys) => setParam("report_status", Array.from(keys))}
      label={t("Report status")}
      items={LEGACY_REPORT_STATUS_OPTIONS}
      selectionMode="multiple"
      testID="legacy-report-status-filter"
    />
  );
}
